import { PageCardProgram } from './CardProgram';
import { PageCardProgramInformation } from './Information';
import { PageCardProgramsOverview } from './Overview';

export { PageCardProgramsOverview } from './Overview';

export const CARD_PROGRAMS = {
  CardPrograms: PageCardProgramsOverview,
  CardProgramSection: PageCardProgram,
  CardProgramInformation: PageCardProgramInformation,
} as const;
